import { useEffect, useMemo } from 'react';
import { useWebsiteSettings } from '../hooks/useWebsiteSettings';
import { useWebsiteFavicon } from '../hooks/useWebsiteFavicon';
import { useWebsiteLogo } from '../hooks/useWebsiteLogo';
import { applySiteMetaTags, buildSiteMetaBundle } from '../helper/websiteMeta';

const siteUrl =
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '');

const WebsiteHead = () => {
    const { settings } = useWebsiteSettings();
    const { faviconUrl } = useWebsiteFavicon();
    const { logoUrl } = useWebsiteLogo();

    const metaBundle = useMemo(
        () =>
            buildSiteMetaBundle(settings, {
                siteUrl,
                imageUrl: logoUrl?.startsWith('http') ? logoUrl : '',
            }),
        [settings.systemTitle, settings.institutionName, logoUrl],
    );

    useEffect(() => {
        applySiteMetaTags(metaBundle);
    }, [metaBundle]);

    useEffect(() => {
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = faviconUrl;
    }, [faviconUrl]);

    return null;
};

export default WebsiteHead;
